import storage from './storage'
import router from 'utils/router'
import isClient from './isClient'

export const handlePivoOrigin = () => {
  const utmSource = router.getQueryString('utm_source')

  if (utmSource === 'pivo') {
    storage.local.setItem('is_pivo', true)
  }
}

export const isPivo = () => {
  if (!isClient()) return false

  return storage.local.getItem('is_pivo') || false
}

export const getPivoUrl = () => {
  return isPivo() ? storage.session.getItem('startSourceURL') : null
}
